export default "/images/vendor/flag-icon-css/flags/1x1/kz.svg?ac6fa1a3ca93e95637cf5084e9dfad24";